'use client';

const ShowcaseCard = ({ client, title, icon, image, text }) => {
  return (
    <div className="showcase__card">
      <img src={require(`@/assets/images/logos/${icon}`).default.src} loading="lazy" alt={`${client} logo`} className="showcase__icon" />
      <img src={require(`@/assets/images/showcase/${image}`).default.src} loading="lazy" alt={`${title} promo`} className="showcase__image" />

      <div className="showcase__info">
        <h3>{client} - {title}</h3>
        <p>{text}</p>
      </div>
    </div>
  )
}

export default ShowcaseCard;
